'use strict';

/**
 * @private
 * @function
 * @description jquery UI Select Menu widget to prepend span tag for the country flag.
 */
function selectMenuWithCountryFlag(){
    //Select menu widget to prepend span tag for the country flag on selected dropdown and options.
    $.widget('ui.selectmenu', $.ui.selectmenu, {
        _renderItem: function (ul, item) {
            var _div = $('<div></div>');
            var li = item.element.attr('key') ? $("<li data-key='" + item.element.attr('key') +"'></li>") : $("<li></li>");

            if (item.disabled) {
                li.addClass('ui-state-disabled');
            }

            this._setText(_div, item.label);
            _div.appendTo(li);

            var setClass = item.element.attr('class');
            if (typeof setClass != 'undefined' && setClass !== '') {
                _div.prepend('<span class=\'' + setClass + '\'></span>');
                _div.prepend(item.element.attr('data-shade'));
            }

            return li.appendTo(ul);
        },
        _renderButtonItem: function (item) {
            var buttonItem = $('<span>', {
                'class': 'ui-selectmenu-text'
            })
            this._setText(buttonItem, item.label);

            var setClass = item.element.attr('class');
            if (typeof setClass != 'undefined' && setClass !== '') {
                buttonItem.prepend('<span class=\'' + setClass + '\'></span>');
                buttonItem.prepend(item.element.attr('data-shade'));
            }

            return buttonItem;
        }
    });
}

/**
 * @private
 * @function
 * @description jquery UI Select Menu.
 */
function selectMenu() {
    $('select').length && $('select').selectmenu({
        //Add class to Dropdown Set for css targeting
        width: false,
        position: {
            my: 'left top',
            at: 'left bottom',
            collision: 'flip flip'
        },
        // Ensure only one selectmenu is open at a time
        open: function () {
            const currentWidget = $(this).selectmenu('widget')[0];
            selectMenuSingleIntance(currentWidget);
        }
    });

    // If a combobox is clicked (mousedown) close other open selectmenus before this one opens
    $('body').on('mousedown', '[role="combobox"]', function () {
        selectMenuSingleIntance(this);
    });

    // Support keyboard opening (Space / Enter)
    $('body').on('keydown', '[role="combobox"]', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
            selectMenuSingleIntance(this);
        }
    });
} 

/**
 * @private
 * @function
 * @description jquery UI Country selector menu init
 */
function countrySelectDropdown() {
    $('#selectcountry').length && $('#selectcountry').selectmenu();
    $('#header-selectcountry').length && $('#header-selectcountry').selectmenu({
        position: {
            my: 'left+10 top+15',
            at: 'left bottom',
            of: '#country-selector'
        }
    });
}

// method to refresh selectmenu
function selectMenuRefresh() {
    $('body').on('change', 'select:not(.widgetSelect)', function(){
        $(this).selectmenu().selectmenu('refresh');
    });
}

// method to open single instance at a time; if 'current' is provided, it will be kept open
function selectMenuSingleIntance(current) {
    const $open = $('[role="combobox"][aria-expanded="true"]');
    if ($open.length > 0) {
        $open.each(function () { // anyone that is open
            if (current && $(this)[0] === current) {
                // skip closing the current one
                return;
            }
            $(this).prev().selectmenu('close');
        });
    }
}

//Remove native select options on ipad landscape (orientation)
function selectMenuInDevice() {
    if (navigator.userAgent.match(/(iPad)/)) {
        $(window).on('orientationchange', function() {
            $('select').length && $('select').blur();
        });
    }
}

export default {    
    selectMenu: selectMenu,
    selectMenuRefresh: selectMenuRefresh,
    selectMenuSingleIntance: selectMenuSingleIntance,
    selectMenuWithCountryFlag: selectMenuWithCountryFlag,
    selectMenuInDevice: selectMenuInDevice,
    countrySelectDropdown: countrySelectDropdown
}
